import Auth from "firebase-auth-lite";

const auth = new Auth({
    apiKey: 'AIzaSyCNP8cF51ZwsH4ukoKKcJUUSQXN2E23rXI',
    redirectUri: process.env['REACT_APP_REDIRECT_URI']
});

export default auth;
